import React from "react";
import { Clock } from "lucide-react";

/**
 * Small uniform "how often is this data refreshed?" strip placed at the top of
 * every client tab. Lives in one place so the wording stays consistent and the
 * spot to look is predictable — clients/agencies should never wonder whether a
 * number is live, weekly, monthly, or on-demand.
 *
 * Usage:
 *   <TabFreshnessNote testid="overview-freshness">
 *     Live · key metrics refreshed each visit. Rank movers update weekly.
 *   </TabFreshnessNote>
 */
export default function TabFreshnessNote({ children, testid = "tab-freshness-note", savedAt }) {
  return (
    <div
      data-testid={testid}
      className="flex items-start gap-1.5 text-[10.5px] text-[#718096] font-mono-tight leading-snug"
    >
      <Clock className="h-3 w-3 mt-[1px] shrink-0 text-[#a0aec0]" />
      <span>
        {savedAt
          ? `Frozen · showing saved copy from ${new Date(savedAt).toLocaleDateString()} — no live lookups.`
          : children}
      </span>
    </div>
  );
}
